import type { FormEvent } from 'react';

import { CardElement } from '@stripe/react-stripe-js';
import type { Stripe, StripeElements } from '@stripe/stripe-js';

interface ReturnProps {
  handleSubmit: (
    event: FormEvent,
    fetcher: any,
    stripeSession: Stripe | null,
    elements: StripeElements | null,
    email: string,
  ) => Promise<void>;
}

const useGiftFormCheckout = (isInternalCheckout: boolean): ReturnProps => {
  const handleSubmit = async (
    event: FormEvent,
    fetcher: any,
    stripeSession: Stripe | null,
    elements: StripeElements | null,
    email: string,
  ) => {
    const formData = new FormData(event.target as HTMLFormElement);

    if (isInternalCheckout && elements && stripeSession) {
      const card = elements.getElement(CardElement);
      const result = await stripeSession.createToken(card as any);

      if (result.error) {
        throw new Error(
          result.error?.message || 'Something went wrong while processing your card details, please try again',
        );
      }

      const paymentMethod = await stripeSession.createPaymentMethod({
        type: 'card',
        // biome-ignore lint/style/noNonNullAssertion: Keep this for now
        card: elements.getElement(CardElement)!,
        billing_details: {
          email,
        },
      });

      if (paymentMethod?.paymentMethod?.id) {
        formData.append('payment_method', paymentMethod.paymentMethod.id);
      }
    }

    fetcher.submit(formData, { method: 'post', action: '/upgrade' });
  };

  return {
    handleSubmit,
  };
};

export default useGiftFormCheckout;
